const LegalForms = [
    {id: '120', name: 'ПРИВАТНЕ ПІДПРИЄМСТВО'},
    {id: '140', name: 'ДЕРЖАВНЕ ПІДПРИЄМСТВО'},
    {id: '145', name: 'КАЗЕННЕ ПІДПРИЄМСТВО'},
    {id: '150', name: 'КОМУНАЛЬНЕ ПІДПРИЄМСТВО'},
    {id: '160', name: 'ДОЧІРНЄ ПІДПРИЄМСТВО'},
    {id: '193', name: 'СПІЛЬНЕ ПІДПРИЄМСТВО'},
    {id: '230', name: 'АКЦІОНЕРНЕ ТОВАРИСТВО'},
    {id: '231', name: 'ВІДКРИТЕ АКЦІОНЕРНЕ ТОВАРИСТВО'},
    {id: '232', name: 'ЗАКРИТЕ АКЦІОНЕРНЕ ТОВАРИСТВО'},
    {id: '235', name: 'ДЕРЖАВНА АКЦІОНЕРНА КОМПАНІЯ (ТОВАРИСТВО)'},
    {id: '240', name: 'ТОВАРИСТВО З ОБМЕЖЕНОЮ ВІДПОВІДАЛЬНІСТЮ'},
    {id: '250', name: 'ТОВАРИСТВО З ДОДАТКОВОЮ ВІДПОВІДАЛЬНІСТЮ'},
    {id: '425', name: 'ДЕРЖАВНА ОРГАНІЗАЦІЯ (УСТАНОВА, ЗАКЛАД)'},
    {id: '430', name: 'КОМУНАЛЬНА ОРГАНІЗАЦІЯ (УСТАНОВА, ЗАКЛАД)'},
    {id: '910', name: 'ПІДПРИЄМЕЦЬ-ФІЗИЧНА ОСОБА'},
    {id: '995', name: 'ІНШІ ОРГАНІЗАЦІЙНО-ПРАВОВІ ФОРМИ'}
];

export default LegalForms;